import React, { useContext, useState } from "react";
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import LogoutIcon from '@mui/icons-material/Logout';
import { AuthContext } from "../hooks/use-auth"
import { BoxCenterStart, BoxFlexStart, BoxFlexStartHeader } from '../style/box'
import { PAGE_NAME } from '../const/user_config'
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';

function ResponsiveAppBar(props) {
    // ページリスト
    const pageMap = {
        [PAGE_NAME.RISK]: { name: '警報基準相当', url: '/risk' },
        [PAGE_NAME.AREA_RISK]: { name: '地域ごと土砂災害リスク', url: '/area_risk' },
        [PAGE_NAME.CHRONOLOGY]: { name: 'クロノロジー分析', url: '/chronology' },
        [PAGE_NAME.SHELTER_ANALYSIS]: { name: '避難所分析', url: '/shelter_analysis' },
        [PAGE_NAME.RIVER]: { name: '河川水位', url: '/river' },
        [PAGE_NAME.SUMMARY]: { name: 'サマリーページ', url: '/summary' },
        [PAGE_NAME.RISK_ANALYSIS]: { name: 'リスク分析', url: '/risk_analysis' },
    };

    // 権限のあるページのみに絞る
    const pages = props.tabList.map(page => pageMap[page]?.name).filter(Boolean);
    const page_urls = props.tabList.map(page => pageMap[page]?.url).filter(Boolean);

    const { signOutFunc } = useContext(AuthContext);
    const navigate = useNavigate();
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [isSearchDrawerOpen, setIsSearchDrawerOpen] = useState(false);

    const cookies = new Cookies(null, { path: '/' });

    const handleOpenNavMenu = (event) => {
        console.log(event.currentTarget)
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        // navigate(url)

        setAnchorElNav(null);
    };

    const handleClickNavMenu = (url) => {
        navigate(url)
        handleCloseNavMenu()
    };

    const handleSingout = async () => {
        await signOutFunc();
        navigate('/signin')
    };

    const handleDrawerOpen = () => {
        setIsSearchDrawerOpen(true);
    };

    const list = (anchor) => (
        <Box
            sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <List>
                {['Inbox', 'Starred', 'Send email', 'Drafts'].map((text, index) => (
                    <ListItem key={text} disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                            </ListItemIcon>
                            <ListItemText primary={text} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
            <Divider />
            <List>
                {['All mail', 'Trash', 'Spam'].map((text, index) => (
                    <ListItem key={text} disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                            </ListItemIcon>
                            <ListItemText primary={text} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Box>
    );

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setIsSearchDrawerOpen(!isSearchDrawerOpen);
    };

    return (
        <AppBar position="static" elevation={0}
            sx={{
                height: '35px',
                minHeight: '35px',
                maxHeight: '35px',
                backgroundColor: '#f5f5f5',
            }}>
            <Container maxWidth={false} disableGutters sx={{ width: '100%', mx: 0 }}>
                <Toolbar variant="dense"
                    disableGutters
                    style={{ height: '35px', minHeight: '35px' }}>
                    {/* スマホ用レイアウト */}
                    <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            onClick={handleOpenNavMenu}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Button
                            variant="outlined"
                            onClick={handleDrawerOpen}
                            sx={{
                                xs: 'flex',
                                md: 'none',
                                height: '30px',
                                mt: '10px',
                                fontWeight: 'bold',
                                fontSize: { xs: '0.6rem', sm: '0.7rem', md: 'inherit' }
                            }}
                        >
                            市町村選択
                        </Button>
                        <Drawer
                            anchor='left'
                            open={isSearchDrawerOpen}
                            onClose={toggleDrawer(false)}
                        >
                            <Box
                                sx={{
                                    height: 'calc(100dvh - 35px)',
                                    width: '100%',
                                    borderRight: '1px solid #aaaaaa',
                                    boxSizing: 'border-box',
                                    p: 1,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    backgroundColor: 'black'
                                }}
                            >
                                <Box sx={{ mt: 1 }}>
                                    {props.leftReset}
                                </Box>
                                <Box sx={{
                                    flexGrow: 1,
                                    minHeight: 0,
                                    overflow: 'auto',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    border: '1px solid white',
                                }}>
                                    {props.leftMenu}
                                </Box>
                                <Box sx={{ mt: 1 }}>
                                    {props.leftLegend}
                                </Box>
                            </Box>
                        </Drawer>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{ display: { xs: 'block', md: 'none' } }}
                        >
                            {pages.map((page, i) => (
                                <MenuItem key={page}
                                    onClick={() => handleClickNavMenu(page_urls[i])}>
                                    <Typography sx={{ textAlign: 'center' }}>{page}</Typography>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                    <BoxCenterStart sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <img
                            src="/EDISON_LOGO_Black.png"
                            alt="EDiSON Logo"
                            style={{ height: 25, width: 130, display: 'flex' }}
                        />
                    </BoxCenterStart>
                    {/* PC用レイアウト */}
                    <BoxFlexStartHeader display={{ xs: 'none', md: 'flex' }}
                        onClick={() => handleClickNavMenu(page_urls[0])}
                    >
                        <img
                            src="/EDISON_LOGO_Black.png"
                            alt="EDiSON Logo"
                            style={{ height: 25, width: 130, display: 'flex' }}
                        />
                    </BoxFlexStartHeader>
                    <BoxFlexStart sx={{ flexGrow: 1, ml: 2, minHeight: '35px', display: { xs: 'none', md: 'flex' } }}>
                        {pages.map((page, i) =>
                            page_urls[i] === props.chooseUrl ?
                                <Button
                                    key={i}
                                    sx={{
                                        // 選択状態の表示,
                                        display: 'block',
                                        fontSize: 'clamp(0.75rem, 0.625rem + 0.33vw, 0.875rem)',
                                        color: 'rgb(0, 124, 176)',
                                        paddingBottom: '0',
                                        paddingTop: '0',
                                        minHeight: '35px',
                                        borderBottom: '2px solid rgb(0, 124, 176)',
                                        borderRadius: '0'

                                    }}
                                >
                                    {page}
                                </Button>
                                :
                                <Button
                                    key={i}
                                    onClick={() => handleClickNavMenu(page_urls[i])}
                                    sx={{
                                        // 非選択状態の表示,
                                        display: 'block',
                                        fontSize: 'clamp(0.75rem, 0.625rem + 0.33vw, 0.875rem)',
                                        color: 'rgb(0, 0, 0)',
                                        paddingBottom: '0',
                                        paddingTop: '0',
                                        minHeight: '35px',
                                        borderBottom: '2px solid transparent',
                                        borderRadius: '0'
                                    }}
                                >
                                    {page}
                                </Button>

                        )}
                    </BoxFlexStart>
                    <Box sx={{ flexGrow: 0, ml: 'auto', mr: 1 }}>
                        <Tooltip title="signout">
                            <IconButton onClick={() => handleSingout()} sx={{ p: 0 }}>
                                <LogoutIcon />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
}

export default ResponsiveAppBar;